import angular from 'angular';
import { react2angular } from 'react18-to-angularjs';
import CompliancyContainer from '../modules/compliancy/CompliancyContainer';
import DocumentsContainer from '../modules/documents/DocumentsContainer';
import EmailsContainer from '../modules/documents/EmailsContainer';

import HomeDashboardContainer from '../modules/home/HomeDashboardContainer';
import InteractionsContainer from '../modules/interactions/InteractionsContainer';
import InteractionOverviewContainer from '../modules/interactions/overview/InteractionOverviewContainer';
import ToInvoiceContainer from '../modules/invoicing/toInvoice/ToInvoiceContainer';
import JobDetailContainer from '../modules/jobs/JobDetailContainer';
import JobOverviewContainer from '../modules/jobs/JobOverviewContainer';
import NotificationOverviewContainer from '../modules/notifications/NotificationOverviewContainer';
import NotificationSettingsContainer from '../modules/notifications/NotificationSettingsContainer';
import PriceGridContainer from '../modules/pricegrids/PriceGridContainer';
import RelationAuditContainer from '../modules/relations/audit/RelationAuditContainer';
import BudgetOverviewContainer from '../modules/relations/budgets/BudgetOverviewContainer';
import InvoiceStreamContainer from '../modules/relations/invoiceStreamOverview/InvoiceStreamContainer';
import RelationOverviewContainer from '../modules/relations/overview/RelationOverviewContainer';
import PlannedRegistrationOverviewContainer from '../modules/relations/plannedRegistrationOverview/PlannedRegistrationOverviewContainer';
import TaskScheduleOverviewContainer from '../modules/relations/taskScheduleOverview/TaskScheduleOverviewContainer';
import AbsencePerEmployeeContainer from '../modules/reporting/absencePerEmployee/AbsencePerEmployeeContainer';
import AbsenceCalendarContainer from '../modules/reporting/absenceCalendar/AbsenceCalendarContainer';
import HoursPerEmployeeReportContainer from '../modules/reporting/hoursPerEmployee/HoursPerEmployeeReportContainer';
import InvoicingHistoryContainer from '../modules/reporting/invoicingHistory/InvoicingHistoryContainer';
import RegistrationsPerResourceCategoryContainer from '../modules/reporting/registrationsPer/RegistrationsPerResourceCategoryContainer';
import RegistrationsPerTaskTemplateContainer from '../modules/reporting/registrationsPer/RegistrationsPerTaskTemplateContainer';
import RegistrationsPerUserContainer from '../modules/reporting/registrationsPer/RegistrationsPerUserContainer';
import RegistrationsPerRelationContainer from '../modules/reporting/registrationsPer/relation/RegistrationsPerRelationContainer';
import RelationRentabilityContainer from '../modules/reporting/relationRentability/RelationRentabilityContainer';
import AssignmentTemplateContainer from '../modules/settings/AssignmentTemplates/AssignmentTemplateContainer';
import TagSettingsContainer from '../modules/settings/Tags/TagSettingsContainer';
import DocumentTreeConfiguration from '../modules/settings/Documents/DocumentTreeConfiguration';
import DocumentTemplateContainer from '../modules/settings/DocumentTemplates/DocumentTemplateContainer';
import InvoiceSchedulesContainer from '../modules/settings/InvoiceSchedules/InvoiceSchedulesContainer';
import TeamsContainer from '../modules/settings/teams/TeamsContainer';
import WorkflowConfigurationContainer from '../modules/settings/WorkflowConfiguration/WorkflowConfigurationContainer';
import TaskDashboardContainer from '../modules/tasks/dashboard/TaskDashboardContainer';
import TaskListContainer from '../modules/tasks/taskList/TaskListContainer';
import TaskOverviewContainer from '../modules/tasks/taskOverview/TaskOverviewContainer';
import RegistrationFormTestContainer from '../shared/components/registration/RegistrationFormTestContainer';
import IntraCompanyBillingContainer from '../modules/invoicing/intraCompany/IntraCompanyBillingContainer';
import HrmOverviewContainer from '../modules/hrm/overview/HrmOverviewContainer';
import InteractionTemplateSettingsContainer from '../modules/settings/InteractionTemplates/InteractionTemplateSettingsContainer';
import TrainingOverviewContainer from '@/modules/training/TrainingOverviewContainer';
import TrainingEmployeeOverviewContainer from '@/modules/training/TrainingEmployeeOverviewContainer';
import EmployeeOverviewContainer from '../modules/settings/Employees/EmployeeOverviewContainer';

import CreateTimerRegistrationModal from '@/modules/registrations/modals/CreateTimerRegistrationModal';
import AppProviders, {
  withDataProvider,
  withModalProvider,
  withQueryClient,
  withTaskTimerProvider,
} from '@/shared/providers/AppProviders';
import TaskboardContainer from '../modules/tasks/taskboard/TaskboardContainer';
import AccessTokensContainer from '@/modules/profile/accessTokens/accessTokens';
import DocumentDetailsModal from '@/modules/documents/details/DocumentDetailsModal';
import TaskDetailsModal from '@/modules/tasks/taskDetails/TaskDetailsModal';
import SingleRelationMailModal from '@/shared/components/email/SingleRelationMailModal';
import CreateToDoModal from '@/modules/tasks/CreateToDoModal';
import InvoicedRelationsModal from '@/modules/relations/relationfile/InvoicedRelationsModal';

import TenantRoleContainer from '@/modules/settings/TenantRoles/TenantRoleContainer';
import AssignmentAnalysisEmployeeRelationMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisEmployeeRelationMatrix';
import AssignmentAnalysisEmployeeTaskMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisEmployeeTaskMatrix';
import WeekPlannerContainer from '@/modules/tasks/weekplanner/WeekPlannerContainer';
import { withTaskflowBillingProvider } from '@/shared/providers/TaskflowBillingProvider';
import AssignmentAnalysisEmployeeCapacityReport from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisEmployeeCapacityReport';

const componentsModule = angular
  .module('cloudX.components', [])
  //
  // add here all your top level react components
  //
  .component(
    'relationCompliancyContainer',
    react2angular(AppProviders(CompliancyContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component('currencySymbol', {
    template: '{{$ctrl.currencySymbol}}',
    controller: [
      'dataCache',
      function CurrencySymbolController(dataCache) {
        var currencyCode = dataCache.getDefaultCompany().currencyCode;
        this.currencySymbol = '€';

        if (currencyCode == 'ZAR') {
          this.currencySymbol = 'R';
        }
      },
    ],
  })
  .component(
    'documentsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(DocumentsContainer)))),
      ['searchParams', 'documentId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'documentDetailsModal',
    react2angular(
      AppProviders(DocumentDetailsModal),
      ['documentId', 'show', 'onClose', 'onSave'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskDetailsModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskDetailsModal)))),
      ['task', 'show', 'onClose', 'onSave', 'showSendEmailButton'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'createToDoModal',
    react2angular(
      AppProviders(CreateToDoModal),
      ['relationId', 'show', 'onClose', 'onSave'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoicedRelationsModal',
    react2angular(
      AppProviders(InvoicedRelationsModal),
      ['relationId', 'show', 'onClose', 'onSave'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'emailsContainer',
    react2angular(AppProviders(EmailsContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component(
    'relationOverviewContainer',
    react2angular(
      AppProviders(RelationOverviewContainer),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'jobOverviewContainer',
    react2angular(AppProviders(JobOverviewContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component(
    'jobDetailContainer',
    react2angular(
      AppProviders(JobDetailContainer),
      ['jobId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoiceSchedulesContainer',
    react2angular(
      AppProviders(InvoiceSchedulesContainer),
      ['editScheduleId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'workflowConfigurationContainer',
    react2angular(
      AppProviders(WorkflowConfigurationContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'priceGridContainer',
    react2angular(AppProviders(PriceGridContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component(
    'documentTreeConfiguration',
    react2angular(
      AppProviders(DocumentTreeConfiguration),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'tagSettingsContainer',
    react2angular(
      AppProviders(TagSettingsContainer),
      ['tab'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'interactionTemplateSettingsContainer',
    react2angular(
      AppProviders(InteractionTemplateSettingsContainer),
      ['tab'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'documentTemplateContainer',
    react2angular(
      AppProviders(DocumentTemplateContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'teamsContainer',
    react2angular(AppProviders(TeamsContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component(
    'relationRentabilityContainer',
    react2angular(
      AppProviders(RelationRentabilityContainer),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoicingHistoryContainer',
    react2angular(
      AppProviders(InvoicingHistoryContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'hoursPerEmployeeReportContainer',
    react2angular(
      AppProviders(HoursPerEmployeeReportContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'toInvoiceContainer',
    react2angular(
      AppProviders(ToInvoiceContainer),
      ['searchParams'],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'intraCompanyBillingContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(IntraCompanyBillingContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'notificationOverviewContainer',
    react2angular(
      AppProviders(NotificationOverviewContainer),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'interactionsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(InteractionsContainer)))),
      ['searchParams', 'openMailModal'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'interactionOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(InteractionOverviewContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskScheduleOverviewContainer',
    react2angular(
      AppProviders(TaskScheduleOverviewContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoiceStreamContainer',
    react2angular(
      AppProviders(InvoiceStreamContainer),
      [],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'assignmentTemplateContainer',
    react2angular(
      AppProviders(AssignmentTemplateContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerRelationContainer',
    react2angular(
      AppProviders(RegistrationsPerRelationContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerResourceCategoryContainer',
    react2angular(
      AppProviders(RegistrationsPerResourceCategoryContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerTaskTemplateContainer',
    react2angular(
      AppProviders(RegistrationsPerTaskTemplateContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerUserContainer',
    react2angular(
      AppProviders(RegistrationsPerUserContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'homeDashboardContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(HomeDashboardContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'plannedRegistrationOverviewContainer',
    react2angular(
      AppProviders(PlannedRegistrationOverviewContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationFormTestContainer',
    react2angular(
      AppProviders(RegistrationFormTestContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'notificationSettingsContainer',
    react2angular(
      AppProviders(NotificationSettingsContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'absencePerEmployeeContainer',
    react2angular(
      AppProviders(AbsencePerEmployeeContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'absenceCalendarContainer',
    react2angular(
      AppProviders(AbsenceCalendarContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'relationAuditContainer',
    react2angular(
      AppProviders(RelationAuditContainer),
      ['relationId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'budgetOverviewContainer',
    react2angular(
      AppProviders(BudgetOverviewContainer),
      [],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'taskOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskOverviewContainer)))),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskListContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskListContainer)))),
      ['searchParams', 'taskId', 'sort', 'desc'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskDashboardContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskDashboardContainer)))),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskboardContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(
            withModalProvider(
              withTaskTimerProvider(withTaskflowBillingProvider(TaskboardContainer)),
            ),
          ),
        ),
      ),
      [
        'relation',
        'invoiceStreamId',
        'taskTemplateId',
        'plannedTaskId',
        'kpi',
        'userId',
        'onlySubtasksForAssignedUser',
        'userIsNextAssignedUser',
        'openPlannedTaskDetailModal',
        'deadlineFrom',
        'deadlineUntil',
        'createTaskForRelation',
      ],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'createTimerRegistrationModal',
    react2angular(
      AppProviders(CreateTimerRegistrationModal),
      ['initialValue', 'onClose', 'onSave', 'show'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'accessTokensContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(withTaskTimerProvider(AccessTokensContainer))),
        ),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'hrmOverviewContainer',
    react2angular(AppProviders(HrmOverviewContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component(
    'tenantRoleContainer',
    react2angular(AppProviders(TenantRoleContainer), [], ['$state', '$translate', 'dataCache']),
  )
  .component(
    'trainingOverviewContainer',
    react2angular(
      AppProviders(TrainingOverviewContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'trainingEmployeeOverviewContainer',
    react2angular(
      AppProviders(TrainingEmployeeOverviewContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'assignmentAnalysisEmployeeRelationMatrix',
    react2angular(
      AppProviders(AssignmentAnalysisEmployeeRelationMatrix),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'assignmentAnalysisEmployeeTaskMatrix',
    react2angular(
      AppProviders(AssignmentAnalysisEmployeeTaskMatrix),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'assignmentAnalysisEmployeeCapacityReport',
    react2angular(
      AppProviders(AssignmentAnalysisEmployeeCapacityReport),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'employeeOverviewContainer',
    react2angular(
      AppProviders(EmployeeOverviewContainer),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'weekPlannerContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(withTaskTimerProvider(WeekPlannerContainer))),
        ),
      ),
      ['filters'],
      ['$state', '$translate', 'dataCache'],
    ),
  );

export default componentsModule.name;
